// extracted by mini-css-extract-plugin
export default {"primaryItem":"_497d7fcb","primaryLink":"_b26d545e","primaryImage":"_a9fe499","productItems":"_e6f03a9f","fullHeight":"_b8ffafbe","shimmerLoadingBackground":"_a457867f"};